angular.module("app.modalControllers", []).controller("BrowseFromServerModalController", [
    '$scope',
    '$uibModalInstance',
    'preloadedImages',
    function ($scope, $modalInstance, preloadedImages) {

        $scope.images = preloadedImages;

        $scope.ok = function () {
            $modalInstance.close([$scope.imageToUse]);
        };

        $scope.cancel = function () {
            $modalInstance.dismiss('cancel');
        };

        $scope.useImage = function (image) {
            $scope.imageToUse = angular.copy(image);
        };


        $scope.getImageStyles = function (image) {
            var styles = {};
            styles["max-width"] = '100px';
            styles["max-height"] = '100px';
            styles["min-width"] = '100px';
            styles["min-height"] = '100px';
            styles["background-size"] = 'contain';
            styles["background-repeat"] = 'no-repeat';
            styles["background-position"] = '50% 0';
            styles["overflow"] = 'hidden';
            styles["display"] = 'inline-block';
            styles["background-image"] = "url('" + image.fileUrl + "')";
            return styles
        }

    }
]);